<div class="operation-shell">
  <aside class="side-menu">
    @if (attendanceAvailable) {
      <button class="side-link" type="button" (click)="openAttendance()">出欠・参加管理</button>
    }
    @if (surveyAvailable) {
      <button class="side-link" type="button" (click)="openSurvey()">アンケート</button>
    }
    <button class="back-button" mat-raised-button type="button" (click)="back()">一覧に戻る</button>
  </aside>

  <main class="main-area">
    @if (loading) {
      <div class="spinner"><mat-spinner diameter="56"></mat-spinner></div>
    } @else if (errorMessage) {
      <div class="error-box" role="alert">{{ errorMessage }}</div>
      <button mat-raised-button type="button" (click)="back()">一覧に戻る</button>
    } @else if (settings) {
      <header class="page-header">
        <div>
          <p class="eyebrow">担当イベント</p>
          <h1>{{ settings.eventTitle }}</h1>

        </div>
      </header>

      <section class="event-brief" aria-labelledby="event-brief-title">
        <h2 id="event-brief-title">当日の確認情報</h2>
        <dl>
          <div>
            <dt>開催日時</dt>
            <dd>
              @for (schedule of settings.operationalBrief.schedules; track schedule.dayIndex) {
                <span>{{ scheduleLabel(schedule) }}</span>
              } @empty { <span>未設定</span> }
            </dd>
          </div>
          <div><dt>対象組織</dt><dd>{{ settings.operationalBrief.targetOrganization || '未設定' }}</dd></div>
          <div><dt>対象者</dt><dd>{{ settings.operationalBrief.participantCategory || '未設定' }}</dd></div>
        </dl>
      </section>

      <section class="feature-list" aria-label="担当する機能">
        @if (attendanceAvailable) {
          <article class="feature-card">
            <div>
              <span class="feature-state">{{ settings.releaseControls.attendance.canWrite && settings.attendanceSelected ? '利用中' : '閲覧のみ' }}</span>
              <h2>出欠・参加管理</h2>

              @if (!settings.releaseControls.attendance.canWrite || !settings.attendanceSelected) {
                <p class="notice">{{ settings.releaseControls.attendance.message }}</p>
              }
            </div>
            <button mat-raised-button class="primary" type="button" (click)="openAttendance()">
              出欠・参加管理を開く
            </button>
          </article>
        }

        @if (surveyAvailable) {
          <article class="feature-card">
            <div>
              <span class="feature-state">{{ settings.releaseControls.survey.canWrite && settings.surveySelected ? '利用中' : '閲覧のみ' }}</span>
              <h2>イベントアンケート</h2>

              @if (!settings.releaseControls.survey.canWrite || !settings.surveySelected) {
                <p class="notice">{{ settings.releaseControls.survey.message }}</p>
              }
            </div>
              <button mat-raised-button class="primary" type="button" (click)="openSurvey()">アンケートを開く</button>
          </article>
        }
        @if (!attendanceAvailable && !surveyAvailable) {
          <p class="empty-message">現在利用できる運営機能はありません。</p>
        }
      </section>
      @if(attendanceAvailable){<app-event-brochure [eventId]="eventId" [canWrite]="settings.releaseControls.attendance.canWrite && settings.attendanceSelected"/>}
    }
  </main>
</div>
